import { Component, DestroyRef, ElementRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
// Services
import { SharedService } from 'src/app/shared/services/shared.service';
import { DummyDataService } from 'src/app/shared/services/dummy-data/dummy-data.service';
// Third Party
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { DatePickerConfig, signatureType } from 'src/app/shared/models/constants';
import { Subscription } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { AlertModule } from 'ngx-bootstrap/alert';
import { DateFormatDirective } from 'src/app/shared/directives/date-format.directive';
// Functions
import { getDay, getMonth, getYear } from 'src/app/shared/functions';
// Models
import { Form4473Transferee } from 'src/app/shared/models/general';

@Component({
  selector: 'app-kiosk-selection',
  standalone: true,
  imports: [FormsModule, BsDatepickerModule, AlertModule, DateFormatDirective],
  templateUrl: './kiosk-selection.component.html',
  styleUrl: './kiosk-selection.component.scss',
})
export class KioskSelectionComponent {
  subscriptions = new Subscription();
  private destroyRef = inject(DestroyRef);
  recert: boolean = false;
  birthdate: Date | null;
  name_last: string | null;
  name_first_initial: string | null;
  no_match: boolean = false;
  matched_pending_transferee_4473_id: string;
  bsConfig: Partial<BsDatepickerConfig>;

  constructor(
    protected element: ElementRef,
    private sharedService: SharedService,
    private dummyDataService: DummyDataService   //////////////remove once real pending dispostions are made
  ) {
    this.bsConfig = Object.assign({}, DatePickerConfig);

    // signatureCaptured$
    this.subscriptions.add(
      this.sharedService.signatureCaptured$
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(async (response) => {
          const recert_signature = response;
          let form_4473: Form4473Transferee =
            await this.sharedService.getReserved4473ById(
              this.matched_pending_transferee_4473_id
            );
          form_4473.transferee_recert_signature = recert_signature.signature;
          form_4473.transferee_recert_month = getMonth(this.birthdate);
          form_4473.transferee_recert_day = getDay(this.birthdate);
          form_4473.transferee_recert_year = getYear(this.birthdate);
          await this.sharedService.updateReserved4473Entry(form_4473);
        })
    );
  }
  FindPendingDisposition() {
    const match = this.findPendingDispositionByTransferee();
    if (match) {
      this.resetVariables();
      this.sharedService.openDigitalSignature(signatureType.find(s => s.name === 'buyer_recert').name);
    } else {
      this.no_match = true;
    }
  }
  findPendingDispositionByTransferee(): any | null {
    const transferee = {
      name_last: this.name_last.trim().toUpperCase(),
      name_first_initial: this.name_first_initial.trim().toUpperCase(),
      birth_month: getMonth(this.birthdate),
      birth_day: getDay(this.birthdate),
      birth_year: getYear(this.birthdate),
    };

    const pending_dispositions: any[] = this.dummyDataService.dummyDrafts;
    for (const pending_disposition of pending_dispositions) {
      // find values from pending_disposition
      const pd_name_last = pending_disposition.data.transferee_4473.name_last
        .trim()
        .toUpperCase();
      const pd_name_first_initial = this.firstCharUpper(
        pending_disposition.data.transferee_4473.name_first.trim().toUpperCase()
      );
      const pd_birth_month =
        pending_disposition.data.transferee_4473.birth_month;
      const pd_birth_day = pending_disposition.data.transferee_4473.birth_day;
      const pd_birth_year = pending_disposition.data.transferee_4473.birth_year;

      if (pd_name_last !== transferee.name_last) continue;

      if (pd_name_first_initial !== transferee.name_first_initial) continue;

      if (
        pd_birth_month === transferee.birth_month &&
        pd_birth_day === transferee.birth_day &&
        pd_birth_year === transferee.birth_year
      ) {
        this.matched_pending_transferee_4473_id =
          pending_disposition.transferee_4473['id'];
        return pending_disposition;
      }
    }

    return null;
  }
  onBirthdateChange(value: string | Date | null): void {
    if (value == null) {
      this.birthdate = null;
      return;
    }
  }
  isBirthdateValid(): boolean {
    const b: any = this.birthdate;
    if (!b) return false;
    // Date instance
    if (b instanceof Date) return !isNaN(b.getTime());
    const s = String(b).trim();
    if (!s) return false;
    // explicit literal check (your code may set this string)
    if (s.toUpperCase() === 'INVALID DATE') return false;
    // try parse fallback
    const parsed = new Date(s);
    return !isNaN(parsed.getTime());
  }
  reCert4473() {
    this.recert = true;
  }
  fillOut4473() {
    this.sharedService.kiosk_selection_made$.next('fill_out_form_4473');
  }
  cancel() {
    this.recert = false;
    this.birthdate = null;
    this.name_first_initial = null;
    this.name_last = null;
  }
  onNameFirstInitialInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const cleaned = (input.value || '')
      .replace(/[^A-Za-z]/g, '')
      .slice(0, 1)
      .toUpperCase();
    this.name_first_initial = cleaned;
    // keep input element in sync (ngModel will update, but keep explicit for safety)
    input.value = cleaned;
  }
  resetVariables() {
    this.birthdate = null;
    this.name_last = null;
    this.name_first_initial = null;
    this.no_match = false;
    this.recert = false;
  }
  ngOnDestroy() {
    //    this.sub.unsubscribe();
  }

  private firstCharUpper(input: unknown): string {
    const s = String(input ?? '').trim();
    return s.length ? s.charAt(0).toUpperCase() : '';
  }
}
